import screenbanner from "./images/background/1.jpg";
import mobilrbanner from "./images/background/2.jpg";

import evergreen from './images/property/evr.jpg'
import treetops from "./images/property/tre.jpg"
import vanha from "./images/property/sv.jpg"
import wildernest from "./images/property/sw.jpg"

export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilrbanner,
};

export const LocationData = {
  taglineheading: "Property in West Pune",
  locationtag: "",
  location: [

    {
      name: "Gera's Joy on The Tree Tops",
      image: treetops,
      price: "On Request",
      location: "Hinjawadi",
      bed: "2 & 3 BHK",
      size: "....",
      url: `/gera-joy-on-the-tree-tops`,
    },
    {
      name: "Shapoorji Pallonji Wildernest",
      image: wildernest,
      price: "On Request",
      location: "Hinjawadi",
      bed: " 3,4 BHK & Villa",
      size: "....",
      url: `/shapoorji-pallonji-wildernest`,
    },
    // {
    //   name: "Shapoorji Pallonji Golfland",
    //   image: golfland,
    //   price: "₹1.26 Crs* ",
    //   location: "Vanah",
    //   bed: " 1,2,3 & 4 BHK ",
    //   size: "739 Sq. Ft.",
    //   url: `/shapoorji-pallonji-golfland`,
    // },
    {
      name: "Godrej Evergreen Square",
      image: evergreen,
      price: "On Request",
      location: "Hinjawadi",
      bed: "1,2 & 3 BHK",
      size: "....",
      url: `/godrej-evergreen-square`,
      form:{
        source_id:11,
        api_userPublicKey:`hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey:`jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id:130,
        builder_id:`103`,
        project_id:`477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },



  ],
};